import { createFileRoute } from '@tanstack/react-router';
import { Integrations } from '../../organisms/Integrations';
import { FullLoader } from '@sc/shared-ui';

export const Route = createFileRoute('/_authenticated/integrations')({
  component: RouteComponent,
  wrapInSuspense: true,
  pendingComponent: () => <FullLoader className="size-5" />,
  validateSearch: (search) => ({
    code: search.code,
    state: search.state,
  }) as {
    code?: string | undefined;
    state?: string | undefined; 
  } | undefined
,
});

function RouteComponent() {
  return <Integrations />;
}
